"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.resetCreator = resetCreator;
var _actions = require("../../actions");
function resetCreator(dispatch) {
  return () => dispatch((0, _actions.formReset)());
}